import { request } from 'shared/api'

const formatDate = inputDate => {
    let dd = String(inputDate.getDate()).padStart(2, '0')
    let mm = String(inputDate.getMonth() + 1).padStart(2, '0') // January is 0!
    let yyyy = inputDate.getFullYear()
    let string = yyyy + '-' + mm + '-' + dd
    return string
}

const contentTypes = {
    'GIFs & Stickers': 'gif,sticker',
    GIFs: 'gif',
    Stickers: 'sticker',
    Stories: 'story',
}

export type LeaderboardItem = {
    viewCount: number
    contentType: string
    contentId: string
}

export type AggregationData = {
    viewCount: number
    uploadCount: number
}

export const getLeaderboard = (token, contentType, dateRange) => {
    let startDate = formatDate(dateRange[0])
    let endDate = formatDate(dateRange[1])

    const url = `/api/v2/users/leaderboard/?start_dt=${startDate}&end_dt=${endDate}&content_type=${contentTypes[contentType]}&limit=50`
    return request(
        url,
        {
            headers: {},
            credentials: 'omit', // prevent sending cookies in the request (this was overriding the provided token)
        },
        token
    ) as Promise<LeaderboardItem[]>
}

export const getAggregations = (token, contentType, dateRange) => {
    let startDate = formatDate(dateRange[0])
    let endDate = formatDate(dateRange[1])
    const url = `/api/v2/users/aggregations/?start_dt=${startDate}&end_dt=${endDate}&content_type=${contentTypes[contentType]}&limit=50`
    return request(
        url,
        {
            headers: {},
            credentials: 'omit', // prevent sending cookies in the request (this was overriding the provided token)
        },
        token
    ) as Promise<AggregationData>
}

export const getCsvLink = (contentType, dateRange, username) => {
    let startDate = formatDate(dateRange[0])
    let endDate = formatDate(dateRange[1])

    const url = `/api/v2/users/csv/?start_dt=${startDate}&end_dt=${endDate}&content_type=${contentTypes[contentType]}&username=${username}`

    return url as string
}
